import { delay, put } from "redux-saga/effects";
import { fetchPCLocationAutocomplete } from "../../../api/v1/autocomplete/fetchPCLocationAutocomplete";
import Logger from "../../../utils/logger";
import { actions } from "../actions";

export function* fetchPCLocationAutocompleteSaga(
  action: actions.IFetchPCLocationAutocomplete
) {
  if (action.queryString.length < 2) {
    yield put(actions.setLocationCategories([]));
    return;
  }

  yield delay(200);

  try {
    const { categories } = yield fetchPCLocationAutocomplete(
      action.queryString
    );
    yield put(actions.setLocationCategories(categories));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setLocationCategories([]));
    yield put(actions.setLocationAutocompleteError(true));
  }
}
